<template>
  <v-row>
    <v-col>
      <v-btn small @click="$emit('open-dialog')">
        {{ serviceName }}アフィリエイトを設定
      </v-btn>
    </v-col>
    <v-col v-if="affiLink">
      <v-btn
        text
        small
        :href="affiLink"
        target="_blank"
        rel="noopener noreferrer"
        >設定中のリンク</v-btn
      >
      <v-btn text small @click="$emit('delete-affi-link')"
        >設定を解除する</v-btn
      >
    </v-col>
    <v-col v-else>未設定</v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    serviceName: {
      type: String,
      required: true
    },
    affiLink: {
      type: String,
      required: true
    }
  }
}
</script>
